"use strict";

exports.__esModule = true;
exports.default = capitalize;

function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/lib/utils/capitalize.js
// module id = 171
// module chunks = 35783957827783 114276838955818